export const dialogInputSx = {
  height: 36,
  fontSize: 14,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'secondary.main',
    borderWidth: '0.8px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'secondary.main' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'secondary.main',
    borderWidth: '0.8px',
  },
} as const;

export const DIALOG_PX = '40px';

export const dialogPaperSx = { width: 696, borderRadius: '4px', py: 2 } as const;
